import { useCallback } from 'react';
import { useSetRecoilState } from 'recoil';
// import { addBreadcrumb, captureException } from '@sentry/react';
import {
	Percomatic,
	api as apiMethods
} from '@biggby-coffee/percomatic-typescript';

import { modifyingState } from '../../Product/atoms';
import { percomaticState } from '../../atoms';

const spreadApiMethods = { ...apiMethods };

type ApiMethods = typeof spreadApiMethods;

export const makeApiCallHook =
	<
		TMethodName extends keyof ApiMethods,
		TArgs extends Parameters<ApiMethods[TMethodName]>,
		TMethod extends (...args: TArgs) => Promise<Percomatic.State>
	>(
		_name: TMethodName,
		method: TMethod
	) =>
	(
		onComplete?: (state: Percomatic.State) => void
	): ((...args: TArgs) => void) => {
		const setModifying = useSetRecoilState(modifyingState);
		const setPercomaticState = useSetRecoilState(percomaticState);

		return useCallback(
			(...args) => {
				// console.debug(`making api call "${name}(${args.join(', ')})"`);

				setModifying(true);

				// addBreadcrumb({
				// 	level: 'info',
				// 	category: 'percomatic',
				// 	message: name,
				// 	data: {
				// 		args
				// 	}
				// });

				method(...args)
					.then(state => {
						setPercomaticState(state);

						setModifying(false);
						onComplete && onComplete(state);
					})
					.catch(err => {
						console.error(err);
						// captureException(err);
					});
			},
			[setModifying, setPercomaticState, onComplete]
		);
	};
